import axios from 'axios'
import { AuthModel, UserModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/api/auth/verify_token`
export const REFRESH_TOKEN_URL = `${API_URL}/api/auth/refresh`
export const LOGIN_URL = `${API_URL}/api/auth/login`
export const REQUEST_PASSWORD_URL = `${API_URL}/senha/email`
export const RESET_PASSWORD_URL = `${API_URL}/senha/resetar`

// Server should return AuthModel
export function login(email: string, password: string, captchaToken: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
    captchaToken,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string, captchaToken: string) {
  return axios.post<{ result: boolean; message?: string }>(REQUEST_PASSWORD_URL, {
    email,
    captchaToken,
  })
}

export function resetPassword(token: string | null, email: string | null, password: string, password_confirmation: string) {
  return axios.post<{ result: boolean }>(RESET_PASSWORD_URL, {
    token,
    email,
    password,
    password_confirmation,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function refreshToken() {
  return axios.post(REFRESH_TOKEN_URL)
}

export function resendVerificationEmail(email: string) {
  return axios.post(`${API_URL}/api/verificar-email/reenviar`, {
    email,
  })
}

export function verifyEmail(token: string, email: string) {
  return axios.post(`${API_URL}/api/verificar-email/verificar`, {
    token,
    email,
  })
}

export function logout() {
  return axios.post(`${API_URL}/api/auth/logout`)
}